import type { SlotsSearchResponseV4 } from "../__generated/api";

export async function fetchSlots(
  params: Record<string, unknown>,
  restUrl: string,
): Promise<SlotsSearchResponseV4[]> {
  const route = `v4/facilities/${String(params.facilityCode)}/slots`;
  const url = `${restUrl}${route}`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Client-Application": process.env.APP_NAME ?? "Aspen Scheduler",
      },
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      throw new Error(`POST: ${route} returned invalid status: ${response.status}`);
    }

    return response.json() as Promise<SlotsSearchResponseV4[]>;
  } catch {
    return [];
  }
}
